import isEmpty from "lodash.isempty";

function getFilterValue(filterName, vacancy) {
  switch (filterName) {
    case "location":
      return {
        coords: {
          lat: vacancy?.location?.geoLocation?.coordinates[0][1],
          lng: vacancy?.location?.geoLocation?.coordinates[0][0],
        },
      };
    case "locationLabel":
      return vacancy?.location?.formattedAddress || vacancy?.location?.city;
    default:
      return vacancy?.[filterName];
  }
}

function normalizeFiltersByRelatedTo(vacancy, relatedTo) {
  return relatedTo.reduce((acc, curr) => {
    const filterValue = getFilterValue(curr.filterName, vacancy);

    if (!isEmpty(filterValue)) {
      acc[curr.filterName] = filterValue;
    }

    return acc;
  }, {});
}

export default normalizeFiltersByRelatedTo;
